import React from 'react';

import { FeedbackIcon } from '@atlaskit/logo/feedback/icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <FeedbackIcon size="xsmall" label="" />;

export const useFeedback = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.FEEDBACK,
		analyticsName: Products.FEEDBACK,
		...options,
	});
